import { render } from "./Rekening.vue?vue&type=template&id=47aba410"
import script from "./Rekening.vue?vue&type=script&lang=js"
export * from "./Rekening.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__